import { descreverChegadaVeiculo, getVxEstado, registroForaDoTms, registroIncompleto } from '../components/tanStackColumns';

// Filtros por coluna da programação Havan. Valem para os dois turnos e combinam com "E".
// "Vazio" considera o que aparece na tela (ex.: motorista vazio = sem motorista na programação e no TMS).
// Para um filtro novo aparecer no painel: inclua a coluna aqui e coloque-a em FILTROS_CLICAVEIS ou FILTROS_DIGITAVEIS.

const texto = valor => String(valor ?? '').trim();
const normalizar = valor => texto(valor).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
const dia = valor => texto(valor).slice(0, 10);

export const CONDICOES = {
  vazio: { rotulo: 'está vazio', precisaValor: false },
  preenchido: { rotulo: 'está preenchido', precisaValor: false },
  contem: { rotulo: 'contém', precisaValor: true },
  dia: { rotulo: 'é o dia', precisaValor: true },
  igual: { rotulo: 'é', precisaValor: true }
};

const TEXTO = ['contem', 'vazio', 'preenchido'];
const DATA = ['dia', 'vazio', 'preenchido'];

// valor(registro) devolve o que a coluna mostra; opcoes existe para as colunas de escolha (condição "é").
export const COLUNAS_FILTRAVEIS = [
  {
    id: 'situacao',
    grupo: 'Situação',
    rotulo: 'Situação',
    condicoes: ['igual'],
    opcoes: [
      // As linhas em vermelho: falta o motorista ou o veículo (Frota ou Placa cavalo).
      { valor: 'incompleta', rotulo: 'Incompleta (sem motorista ou sem frota/cavalo)' },
      { valor: 'fora_tms', rotulo: 'Fora do TMS' },
      { valor: 'cancelada', rotulo: 'Cancelada' },
      { valor: 'nova', rotulo: 'Nova na definitiva' },
      { valor: 'alterada', rotulo: 'Alterada na definitiva' },
      { valor: 'reativada', rotulo: 'Reativada na definitiva' }
    ],
    // Situação admite mais de um valor ao mesmo tempo (ex.: nova e fora do TMS).
    valor: registro => [
      registroIncompleto(registro) ? 'incompleta' : null,
      registroForaDoTms(registro) ? 'fora_tms' : null,
      registro.cancelado ? 'cancelada' : null,
      !registro.cancelado ? registro.situacao_definitiva : null
    ].filter(Boolean)
  },
  { id: 'ct', grupo: 'Carga', rotulo: 'CT', condicoes: TEXTO, valor: registro => registro.ct || registro.numero_carga },
  { id: 'filial_codigo', grupo: 'Carga', rotulo: 'Nº filial', condicoes: TEXTO, valor: registro => (registro.filial_codigo ?? '').toString() },
  { id: 'filial', grupo: 'Carga', rotulo: 'Filial', condicoes: TEXTO, valor: registro => registro.filial },
  { id: 'tipo_caminhao', grupo: 'Carga', rotulo: 'Tipo de caminhão', condicoes: TEXTO, valor: registro => registro.tipo_caminhao },
  { id: 'box', grupo: 'Carga', rotulo: 'Box', condicoes: TEXTO, valor: registro => registro.box },
  { id: 'observacao_operador', grupo: 'Carga', rotulo: 'Observação', condicoes: TEXTO, valor: registro => registro.observacao_operador },
  // Como as outras colunas de data: o dia, vazio ou preenchido (o da chegada do veículo, só quando há horário).
  { id: 'h_chegada_veiculo', grupo: 'Datas', rotulo: 'H. cheg. veículo', condicoes: DATA, valor: registro => (descreverChegadaVeiculo(registro) ? registro.data_programacao || registro.saida_cdh : null) },
  { id: 'saida_cdh', grupo: 'Datas', rotulo: 'Saída CDH', condicoes: DATA, valor: registro => registro.saida_cdh },
  { id: 'chegada_loja', grupo: 'Datas', rotulo: 'Chegada loja', condicoes: DATA, valor: registro => registro.chegada_loja },
  { id: 'nome', grupo: 'Motorista e veículos', rotulo: 'Motorista', condicoes: TEXTO, valor: registro => registro.nome || registro.nome_motorista },
  { id: 'numero_frota', grupo: 'Motorista e veículos', rotulo: 'Frota', condicoes: TEXTO, valor: registro => registro.numero_frota },
  { id: 'placa_cavalo', grupo: 'Motorista e veículos', rotulo: 'Placa cavalo', condicoes: TEXTO, valor: registro => registro.placa_cavalo },
  { id: 'placa_carreta_1', grupo: 'Motorista e veículos', rotulo: 'Carreta 1', condicoes: TEXTO, valor: registro => [registro.frota_carreta_1, registro.placa_carreta_1].filter(Boolean).join(' / ') },
  { id: 'placa_carreta_2', grupo: 'Motorista e veículos', rotulo: 'Carreta 2', condicoes: TEXTO, valor: registro => [registro.frota_carreta_2, registro.placa_carreta_2].filter(Boolean).join(' / ') },
  { id: 'placa_carreta_3', grupo: 'Motorista e veículos', rotulo: 'Carreta 3', condicoes: TEXTO, valor: registro => [registro.frota_carreta_3, registro.placa_carreta_3].filter(Boolean).join(' / ') },
  // As três carretas juntas (frota e placa): "Sem carreta" e a busca por qualquer carreta do conjunto.
  {
    id: 'carretas',
    grupo: 'Motorista e veículos',
    rotulo: 'Carretas',
    condicoes: TEXTO,
    valor: registro => [1, 2, 3].map(posicao => [registro[`frota_carreta_${posicao}`], registro[`placa_carreta_${posicao}`]].filter(Boolean).join(' / '))
  },
  { id: 'gestor', grupo: 'Motorista e veículos', rotulo: 'Gestor', condicoes: TEXTO, valor: registro => registro.gestor_nome },
  {
    id: 'terceiro',
    grupo: 'Marcações',
    rotulo: 'Terceiro',
    condicoes: ['igual'],
    opcoes: [{ valor: 'sim', rotulo: 'Liberada' }, { valor: 'nao', rotulo: 'Não liberada' }],
    valor: registro => (registro.terceiro ? 'sim' : 'nao')
  },
  {
    id: 'protocolo',
    grupo: 'Marcações',
    rotulo: 'Protocolo',
    condicoes: ['igual'],
    opcoes: [{ valor: 'sim', rotulo: 'Com protocolo' }, { valor: 'nao', rotulo: 'Sem protocolo' }],
    valor: registro => (registro.protocolo ? 'sim' : 'nao')
  },
  {
    id: 'gestor_avisado',
    grupo: 'Marcações',
    rotulo: 'Gestor avisado',
    condicoes: ['igual'],
    opcoes: [{ valor: 'sim', rotulo: 'Avisado' }, { valor: 'nao', rotulo: 'Não avisado' }],
    valor: registro => (registro.gestor_avisado ? 'sim' : 'nao')
  },
  {
    id: 'vx',
    grupo: 'Marcações',
    rotulo: 'VX',
    condicoes: ['igual'],
    opcoes: [{ valor: 'consultar', rotulo: 'A consultar' }, { valor: 'andamento', rotulo: 'Em andamento' }, { valor: 'valida', rotulo: 'Válida' }],
    valor: registro => (registro.cancelado ? 'cancelada' : getVxEstado(registro))
  }
];

const COLUNA_POR_ID = Object.fromEntries(COLUNAS_FILTRAVEIS.map(coluna => [coluna.id, coluna]));

export const colunaFiltravel = id => COLUNA_POR_ID[id];

export const filtroAtende = (registro, filtro) => {
  const coluna = COLUNA_POR_ID[filtro.coluna];
  if (!coluna) return true;
  const atual = coluna.valor(registro);
  const valores = Array.isArray(atual) ? atual : [atual];
  switch (filtro.condicao) {
    case 'vazio': return valores.every(valor => texto(valor) === '');
    case 'preenchido': return valores.some(valor => texto(valor) !== '');
    case 'contem': return valores.some(valor => normalizar(valor).includes(normalizar(filtro.valor)));
    case 'dia': return valores.some(valor => dia(valor) === dia(filtro.valor));
    case 'igual': return valores.some(valor => texto(valor) === texto(filtro.valor));
    default: return true;
  }
};

export const aplicarFiltros = (registros, filtros) => (filtros?.length
  ? (registros || []).filter(registro => filtros.every(filtro => filtroAtende(registro, filtro)))
  : registros || []);

// Texto do chip: "Motorista: está vazio", "Placa cavalo: contém "QZX"", "VX: Em andamento".
export const descreverFiltro = filtro => {
  const coluna = COLUNA_POR_ID[filtro.coluna];
  const condicao = CONDICOES[filtro.condicao];
  if (!coluna || !condicao) return '';
  if (!condicao.precisaValor) return `${coluna.rotulo}: ${condicao.rotulo}`;
  if (filtro.condicao === 'igual') return `${coluna.rotulo}: ${coluna.opcoes?.find(opcao => opcao.valor === filtro.valor)?.rotulo || filtro.valor}`;
  if (filtro.condicao === 'dia') {
    const [ano, mes, diaMes] = dia(filtro.valor).split('-');
    return `${coluna.rotulo}: ${diaMes}/${mes}/${ano}`;
  }
  return `${coluna.rotulo}: contém "${texto(filtro.valor)}"`;
};

// ===== Painel de filtros =====
// Duas partes separadas: botões que só ligam/desligam um critério ("clicáveis") e caixas para digitar um valor
// específico ("digitáveis"). Uma coluna tem no máximo um filtro (exceto Situação, que aceita vários ao mesmo tempo).

const idDoFiltro = ({ coluna, condicao, valor }) => `${coluna}:${condicao}:${valor || ''}`;

const filtroClicavel = (rotulo, coluna, condicao, valor = '') => ({ rotulo, filtro: { coluna, condicao, valor, id: idDoFiltro({ coluna, condicao, valor }) } });

export const FILTROS_CLICAVEIS = [
  {
    grupo: 'Pendências',
    itens: [
      filtroClicavel('Sem motorista', 'nome', 'vazio'),
      filtroClicavel('Sem cavalo', 'placa_cavalo', 'vazio'),
      filtroClicavel('Sem frota', 'numero_frota', 'vazio'),
      filtroClicavel('Sem carreta', 'carretas', 'vazio'),
      filtroClicavel('Incompletas (em vermelho)', 'situacao', 'igual', 'incompleta')
    ]
  },
  {
    grupo: 'Situação',
    itens: [
      filtroClicavel('Fora do TMS', 'situacao', 'igual', 'fora_tms'),
      filtroClicavel('Cancelada', 'situacao', 'igual', 'cancelada'),
      filtroClicavel('Nova na definitiva', 'situacao', 'igual', 'nova'),
      filtroClicavel('Alterada na definitiva', 'situacao', 'igual', 'alterada'),
      filtroClicavel('Reativada na definitiva', 'situacao', 'igual', 'reativada')
    ]
  },
  {
    grupo: 'Marcações',
    itens: [
      filtroClicavel('Liberada para terceiro', 'terceiro', 'igual', 'sim'),
      filtroClicavel('Com protocolo', 'protocolo', 'igual', 'sim'),
      filtroClicavel('Gestor avisado', 'gestor_avisado', 'igual', 'sim'),
      filtroClicavel('VX a consultar', 'vx', 'igual', 'consultar'),
      filtroClicavel('VX em andamento', 'vx', 'igual', 'andamento'),
      filtroClicavel('VX válida', 'vx', 'igual', 'valida')
    ]
  }
];

// Busca por um valor específico: texto (contém, sem acento nem caixa) ou o dia, nas datas.
export const FILTROS_DIGITAVEIS = [
  { grupo: 'Carga', colunas: ['ct', 'filial_codigo', 'filial', 'tipo_caminhao', 'box', 'observacao_operador'] },
  { grupo: 'Motorista e veículos', colunas: ['nome', 'numero_frota', 'placa_cavalo', 'carretas', 'gestor'] },
  { grupo: 'Datas', colunas: ['h_chegada_veiculo', 'saida_cdh', 'chegada_loja'] }
].map(grupo => ({
  grupo: grupo.grupo,
  campos: grupo.colunas.map(id => ({ id, rotulo: COLUNA_POR_ID[id].rotulo, tipo: COLUNA_POR_ID[id].condicoes.includes('dia') ? 'data' : 'texto' }))
}));

export const filtroAtivo = (filtros, filtro) => (filtros || []).some(atual => atual.id === filtro.id);

// Liga/desliga um botão: ligar tira o outro filtro da mesma coluna (ex.: "Sem cavalo" substitui a placa digitada),
// menos em Situação, que soma critérios.
export const alternarFiltro = (filtros, filtro) => {
  const atuais = filtros || [];
  if (filtroAtivo(atuais, filtro)) return atuais.filter(atual => atual.id !== filtro.id);
  const outros = filtro.coluna === 'situacao' ? atuais : atuais.filter(atual => atual.coluna !== filtro.coluna);
  return [...outros, filtro];
};

// Valor digitado no campo (vazio quando a coluna não tem busca digitada).
export const valorDigitado = (filtros, coluna) => {
  const filtro = (filtros || []).find(atual => atual.coluna === coluna && ['contem', 'dia'].includes(atual.condicao));
  return filtro?.valor || '';
};

// Digitar substitui o filtro da coluna; apagar o texto tira o filtro.
export const digitarFiltro = (filtros, campo, valor) => {
  const outros = (filtros || []).filter(atual => atual.coluna !== campo.id);
  if (texto(valor) === '') return outros;
  const condicao = campo.tipo === 'data' ? 'dia' : 'contem';
  return [...outros, { coluna: campo.id, condicao, valor, id: `${campo.id}:${condicao}` }];
};
